module.exports = __webpack_public_path__ + "images/pitpoint_smallc29a4655526f57a1c1e9f7517d51e2a8.png";